import { LoaderFunction } from 'react-router-dom';

import store from '../../../store/store';
import {
  getDeviceDetails,
  getDeviceStatus,
  resetDeviceDetails,
} from '../../../store/slice/health-monitor/device-details';
import { redirect } from 'react-router-dom';

interface DeviceDetailsLoaderParams {
  locationName: string;
  locationId: string;
}

export const loadDeviceDetails: LoaderFunction = async ({ params }) => {
  const { locationId } = params as unknown as DeviceDetailsLoaderParams;

  store.dispatch(resetDeviceDetails());

  try {
    await store.dispatch(getDeviceDetails(locationId)).unwrap();

    const deviceDetailsId = store.getState().deviceDetails.deviceDetails?.id;

    if (!deviceDetailsId) {
      return redirect('/health-monitor');
    }

    await store.dispatch(getDeviceStatus(deviceDetailsId)).unwrap();

    return true;
  } catch (e) {
    console.log(e);

    return redirect('/health-monitor');
  }
};
